

























































import Vue from 'vue'
import Treeview from '@/components/Businesses/Treeview.vue'
import EditBusinessDrawer from '@/components/Businesses/EditBusinessDrawer.vue'
import CreateBusinessDrawer from '@/components/Businesses/CreateBusinessDrawer.vue'
import LinkEntitiesDrawer from '@/components/Businesses/LinkEntitiesDrawer.vue'
import BusinessActions from '@/components/Businesses/BusinessActions.vue'
import EntitiesTable from '@/components/Businesses/EntitiesTable.vue'
import UsersTable from '@/components/Businesses/UsersTable.vue'
import DevicesTable from '@/components/Businesses/DevicesTable.vue'
import AddUserDrawer from '@/components/Users/AddUserDrawer.vue'
import EditUserDrawer from '@/components/Users/EditUserDrawer.vue'
import BusinessStatistics from '@/components/Global/FreeDevices.vue'
import {
  apiDeleteBusiness,
  apiDropdownsBusinesses,
  apiDropdownsCountries,
  apiDropdownsRoles,
  apiGetBusinesses
} from '@/api'
import { mutations, portalState } from '@/state'

type Actions = 'createBusiness' | 'linkEntity' | 'createUser' | 'deleteBusiness'

export default Vue.extend({
  name: 'Businesses',
  components: { Treeview, AddUserDrawer, EditUserDrawer, EditBusinessDrawer, CreateBusinessDrawer, LinkEntitiesDrawer, BusinessActions, EntitiesTable, UsersTable, DevicesTable, BusinessStatistics },
  data () {
    return {
      tab: 'entities',
      countries: [],
      businesses: [],
      roles: [],
      tableSearch: '',
      loadingBusinesses: true,
      dropdownsBusinesses: [],
      selectedEntities: [],
      selectedBusiness: null,
      userToBeEdited: {},
      editBusinessDrawerOpened: false,
      createBusinessDrawerOpened: false,
      editUserDrawerOpened: false,
      addUserDrawerOpened: false,
      linkEntityDrawerOpened: false,
      marginTop: `calc(100vh - ${this.$vuetify.application.top}px - 222px)`
    }
  },
  computed: {
    loggedInUser () {
      return portalState.user
    }
  },
  methods: {
    businessAction (type: Actions) {
      switch (type) {
        case 'createBusiness':
          this.createBusinessDrawerOpened = true
          break
        case 'linkEntity':
          this.linkEntityDrawerOpened = true
          break
        case 'createUser':
          this.addUserDrawerOpened = true
          break
        case 'deleteBusiness':
          this.deleteBusiness()
          break
      }
    },
    getTreeviewAndDropdownBusinesses () {
      this.loadingBusinesses = true
      apiGetBusinesses().then((res: any) => {
        this.businesses = res.data.data
        this.loadingBusinesses = false
      })
      apiDropdownsBusinesses().then((res: any) => {
        this.dropdownsBusinesses = res.data.data
      })
    },
    linkEntitiesResetHandler () {
      this.$refs.EntitiesTable.selectedEntities = []
      this.$refs.EntitiesTable.initialize()
    },
    async deleteBusiness () {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmText', component: 'messages' }, this.selectedBusiness.name))
      if (!isConfirmed) return

      const { id } = this.selectedBusiness

      try {
        mutations.setSnackbar()
        await apiDeleteBusiness(id)
        this.$refs.BusinessesTreeview.selected = []
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
        this.getTreeviewAndDropdownBusinesses()
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      }
    },
    editUserHandler (user: { name: string; id: string }) {
      this.editUserDrawerOpened = true
      this.userToBeEdited = user
    }
  },
  mounted () {
    this.getTreeviewAndDropdownBusinesses()
    apiDropdownsCountries().then((res: any) => {
      this.countries = res.data.data
    })
    apiDropdownsRoles().then((res: any) => {
      this.roles = res.data.data
    })
    if (this.$route.query.search) {
      this.$refs.BusinessesTreeview.search = this.$route.query.search
    }
  },
  watch: {
    tab () {
      this.tableSearch = ''
    },
    editBusinessDrawerOpened (val) {
      if (val) {
        this.linkEntityDrawerOpened = false
        this.editUserDrawerOpened = false
        this.addUserDrawerOpened = false
        this.createBusinessDrawerOpened = false
      }
    }
  }
})
